// material-ui

import showobcmsgicon from '../../../assets/images/show-msg.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const ShowObcMsgIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={showobcmsgicon} alt="Show Obc messages" width="22"  />
    );
};

export default ShowObcMsgIcon;